export const USER_DATA_CACHE_KEY = 'current-user-state' as const
export const USER_STORE_ID_CACHE_KEY = 'current-user-state-storeID' as const
export const USER_FEATURE_FLAGS_CHECK_DEBOUNCE = 500 as const
